// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bc89c274","239":"88445302","453":"25426bc6","732":"ff9d6d1f"}[chunkId] + ".chunk.js";
};